/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isObjEmptyOrNull } from '../../common/UtilityFunctions';
import Styles from '../../css/ServicerEscrowAnalysis.module.css';
import { useCallback } from 'react';
import { Button } from '@mui/material';
import { EscrowAnalysisViews, useServicerEscrowAnalysisContext } from '../../contexts/ServicerEscrowAnalysisContext';
import { useEscrowAnalysisCalculationContext } from '../../contexts/CalculateEscrowAnalysisContext';
import ApplyAEAView from './ApplyAEAView';
import CalculateAEAView from './CalculateAEAView';

const CalculateApplyAEAView = () => {
  const { viewToShow, setViewToShow } = useServicerEscrowAnalysisContext();

  const { escrowAnalysisCalculation, escrowAnalysisCalculated, escrowCalcLoading } =
    useEscrowAnalysisCalculationContext();

  const resetToMenu = useCallback(() => {
    setViewToShow(EscrowAnalysisViews.MAIN_MENU_VIEW);
  }, []);

  const backToMenuButton = () => {
    return (
      <div className={escrowAnalysisCalculated ? Styles.backtomenubutton : Styles.applybutton}>
        <Button
          fullWidth
          className={Styles.whitebutton}
          variant='outlined'
          size='large'
          onClick={() => {
            resetToMenu();
          }}
        >
          {'Back to Menu'}
        </Button>
      </div>
    );
  };

  const showApplyAEAView =
    escrowAnalysisCalculated && !isObjEmptyOrNull(escrowAnalysisCalculation) && !escrowCalcLoading;

  return (
    <div className={Styles.noaeafound}>
      <CalculateAEAView></CalculateAEAView>

      <div className={Styles.applymenurow}>
        {showApplyAEAView && <ApplyAEAView></ApplyAEAView>}

        {backToMenuButton()}
      </div>
    </div>
  );
};

export default CalculateApplyAEAView;
